import { useContext } from 'react';
import { TenantContext } from '../../../context/tenant-context';
import { handleRequest } from '../quipli-service-client';
import {
  StatusTransitionRequirement,
  StatusTransitionRequirementRequest,
  StatusTransitionRequirementSearchRequest,
  Step,
  TransitionableEntity,
} from './status-transition-requirement';
import { StatusTransitionRequirementParsers } from './status-transistion-requirement-parsers';

const apiPrefix = `quipli-service/v1/status-transition`;

export const useStatusTransitionRequirementApiV1 = () => {
  const { tenant, contextPath } = useContext(TenantContext);

  async function search(request: StatusTransitionRequirementSearchRequest): Promise<StatusTransitionRequirement[]> {
    const config = {
      method: 'post',
      url: `${contextPath}${apiPrefix}/search`,
      headers: {
        'X-Tenant': tenant,
      },
      data: request,
    };
    const resp = await handleRequest<StatusTransitionRequirementParsers.StatusTransitionRequirementJson[]>(config);
    return resp.map(StatusTransitionRequirementParsers.toStatusTransitionRequirement);
  }

  async function update(
    entity: TransitionableEntity,
    requirements: StatusTransitionRequirementRequest[],
  ): Promise<void> {
    const config = {
      method: 'patch',
      url: `${contextPath}${apiPrefix}/${entity}`,
      headers: {
        'X-Tenant': tenant,
      },
      data: { requirements },
    };
    await handleRequest<void>(config);
  }

  async function getSteps(request?: {
    stepId?: string[];
    entity?: TransitionableEntity;
    statuses?: string[];
  }): Promise<Step[]> {
    const config = {
      method: 'post',
      url: `${contextPath}${apiPrefix}/steps`,
      headers: {
        'X-Tenant': tenant,
      },
      data: request,
    };
    return (await handleRequest<StatusTransitionRequirementParsers.StepJson[]>(config)).map(
      StatusTransitionRequirementParsers.toStep,
    );
  }

  return { search, update, getSteps };
};
